import React, { Component } from "react";
import { connect } from "react-redux";

import { createChannel, setCurrentChannel, deleteChannel } from "../../store/channels";
import { generateInput } from "../utils/misc";

import { Button, Icon, Menu, Modal, Loader, Segment, Label } from "semantic-ui-react";

import Form from "../utils/Form";
import messagesService from "../../services/messagesService";
import channelService from "../../services/channelsService";

class Channels extends Component {
    state = {
        modalOpen: false,
        modalDeleteOpen: false,
        channel: {},
        notifications: [],
    };

    fields = [
        generateInput({
            name: "channelName",
            min: 2,
            max: 30,
            autoComplete: "on",
            placeholder: "enter channel name",
            label: "name of channel",
            validationlabel: "channel name",
        }),

        generateInput({
            name: "channelDetails",
            min: 6,
            autoComplete: "on",
            placeholder: "enter channel description",
            label: "about the channel",
            validationlabel: "channel description",
        }),
    ];

    componentDidMount() {
        channelService.setOnAddChannelListener(snap => {
            const channel = snap.val();

            messagesService.messagesRef.child(channel.id).on("value", snap => {
                const { currentChannel } = this.props.channels;

                currentChannel && this.handleNotifications(channel.id, currentChannel.id, this.state.notifications, snap);
            });
        });
    }

    componentWillUnmount() {
        this.props.setCurrentChannel(null);

        messagesService.messagesRef.off();
        channelService.channelsRef.off();
    }

    handleNotifications = (channelId, currentChannelId, notifications, snap) => {
        let lastTotal = 0;

        let index = notifications.findIndex(({ id }) => id === channelId);

        if (index !== -1) {
            if (channelId !== currentChannelId) {
                lastTotal = notifications[index].total;

                if (snap.numChildren() - lastTotal > 0) notifications[index].count = snap.numChildren() - lastTotal;
            }

            notifications[index].lastKnownTotal = snap.numChildren();
        } else
            notifications.push({ id: channelId, total: snap.numChildren(), lastKnownTotal: snap.numChildren(), count: 0 });

        this.setState({ notifications });
    };

    clearNotifications = channel => {
        const { notifications } = this.state;

        let index = notifications.findIndex(({ id }) => id === channel.id);

        if (index !== -1) {
            const updatedNotifications = [...notifications];

            updatedNotifications[index].total = notifications[index].lastKnownTotal;

            updatedNotifications[index].count = 0;

            this.setState({ notifications: updatedNotifications });
        }
    };

    getNotificationCount = channel => this.state.notifications.find(({ id }) => id === channel.id)?.count;

    prepareDeleteChannel = (e, channel) => {
        e.stopPropagation();

        this.setState({ modalDeleteOpen: true, channel });
    };

    onDeleteChannel = async channelId => {
        await this.props.deleteChannel(channelId);

        this.props.setActiveChannel(this.props.channels.currentChannel?.id);

        this.onModalClose("modalDeleteOpen");
    };

    onSubmit = async formValues => {
        const { createChannel, currentUser } = this.props;

        await createChannel({
            ...formValues,
            createdBy: { id: currentUser.uid, name: currentUser.displayName, avatar: currentUser.photoURL },
        });

        this.props.setActiveChannel(this.props.channels.currentChannel?.id);

        this.onModalClose("modalOpen");
    };

    changeActiveChannel(channel) {
        const { channels: { currentChannel } = {}, currentUser, setCurrentChannel } = this.props;

        messagesService.updateTyping(false, currentChannel?.id, { id: currentUser?.uid, name: currentUser?.displayName });

        setCurrentChannel(channel);

        this.props.setActiveChannel(channel.id);

        this.clearNotifications(channel);
    }

    onModalClose = modal => this.setState({ [modal]: false });

    renderChannel = channel => (
        <Menu.Item
            key={channel.id}
            name={channel.channelName}
            className="channel-item"
            active={this.props.activeChannel === channel.id}
            onClick={() => this.changeActiveChannel(channel)}>
            # {channel.channelName}
            {channel.createdBy.id === this.props.currentUser?.uid && (
                <Icon name="delete" onClick={e => this.prepareDeleteChannel(e, channel)} />
            )}
            {this.getNotificationCount(channel) ? <Label color="red">{this.getNotificationCount(channel)}</Label> : ""}
        </Menu.Item>
    );

    render() {
        const { modalOpen, modalDeleteOpen, channel } = this.state;
        const { channels: { channels, loading } = {} } = this.props;

        return (
            <>
                <Menu.Menu>
                    <Menu.Item>
                        <span>
                            <Icon name="exchange" /> CHANNELS
                        </span>
                        ({channels.length})
                        <Icon
                            name="add"
                            onClick={() => this.setState({ modalOpen: true })}
                            style={{ cursor: "pointer" }}
                        />
                    </Menu.Item>

                    {/* Channels List */}
                    {loading ? (
                        <Loader active inline="centered" inverted content="Loading" style={{ marginTop: 22 }} />
                    ) : (
                        channels.map(this.renderChannel)
                    )}
                </Menu.Menu>

                <Modal basic open={modalOpen} onClose={() => this.onModalClose("modalOpen")} className="modal-form">
                    <div className="form-container">
                        <div className="form-wrapper">
                            <Modal.Header className="title">
                                <h2>add a channel</h2>
                            </Modal.Header>

                            <Modal.Content>
                                <Form form="createChannel" fields={this.fields} onSubmit={this.onSubmit}>
                                    <Modal.Actions>
                                        <Button color="green" inverted type="submit">
                                            <Icon name="checkmark" /> create
                                        </Button>
                                        <Button color="red" inverted onClick={() => this.onModalClose("modalOpen")}>
                                            <Icon name="remove" /> cancel
                                        </Button>
                                    </Modal.Actions>
                                </Form>
                            </Modal.Content>
                        </div>
                    </div>
                </Modal>

                <Modal
                    basic
                    open={modalDeleteOpen}
                    onClose={() => this.onModalClose("modalDeleteOpen")}
                    className="modal-delete--channel">
                    <Segment className="modal-delete--channel-wrapper">
                        <Modal.Header className="title">
                            <h2>Delete Channel</h2>
                        </Modal.Header>

                        <Modal.Content>
                            <Modal.Description>
                                are you sure you want to delete{" "}
                                <span className="channel-name"># {channel.channelName}</span> channel
                            </Modal.Description>

                            <Modal.Actions>
                                <Button color="red" inverted onClick={() => this.onDeleteChannel(channel.id)}>
                                    <Icon name="remove" /> delete
                                </Button>
                                <Button color="red" inverted onClick={() => this.onModalClose("modalDeleteOpen")}>
                                    <Icon name="checkmark" /> cancel
                                </Button>
                            </Modal.Actions>
                        </Modal.Content>
                    </Segment>
                </Modal>
            </>
        );
    }
}

export default connect(null, { createChannel, setCurrentChannel, deleteChannel })(Channels);
